import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Checkbox, ChevronDownIcon, ChevronUpIcon, Tooltip } from '@labsavvyapp/components'
import { CompendiumPanelWithType } from '../../../../../../../types'
import formatterPrice from '../../../../../../../../../../utils/formatter-price'

const OrdersetCategoryTestItemLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  background-color: transparent;
  border: 0;
  font-family: 'Avenir';
  gap: 10px;
  margin: 5px 0px;
  width: 100%;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: -moz-none;
  -o-user-select: none;
  user-select: none;
  align-items: center;
  align-content: center;
`

const AccordionSection = styled.button`
  background-color: transparent;
  display: grid;
  grid-template-columns: 1fr repeat(2, 65px) 20px;
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  border: 0;
  font-family: 'Avenir';
  gap: 10px;
  width: 100%;
  cursor: pointer;
  align-items: center;

  &:hover {
    background-color: #f3dff0;
    border-radius: 5px;
  }

  svg {
    width: 12px;
    height: 12px;
  }
`

const AccordionTitle = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  text-align: left;
`

const AccordionContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
`

const TestRetailPrice = styled.p`
  font-size: 12px;
  font-family: 'Avenir';
  text-align: left;
`

const Item = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;
  align-items: center;
  align-content: center;
  width: 100%;
`

const PrimaryHeaderItem = styled(Item)`
  height: 30px;
  background-color: #f3f3f3;
  margin-left: 30px;
  padding: 0px 10px;
  width: calc(100% - 30px);
  margin-top: 5px;
`

const SecondaryHeaderItem = styled(Item)`
  height: 30px;
  background-color: white;
  border-bottom: 1px solid #f3f3f3;
  margin-left: 30px;
  padding: 0px 10px;
  width: calc(100% - 30px);
  font-weight: 700;
`

interface OrdersetCategoryTestItemProps {
  data: CompendiumPanelWithType
  isByGroups: boolean
  selectedCodes: string[]
}

export const OrdersetCategoryTestItem = (props: OrdersetCategoryTestItemProps) => {
  const { data, isByGroups, selectedCodes } = props

  const panelCode = data?.code || ''
  const panelName = data?.name || '--'
  const panelContractPrice = data?.contract_price ?? 0
  const panelContractPriceDisplay = formatterPrice(panelContractPrice)
  const panelRetailPrice = data?.retail_price ?? 0
  const panelRetailPriceDisplay = formatterPrice(panelRetailPrice)

  const isOrdersetSelected = selectedCodes.includes(panelCode)
  const isTestPriceZero = data?.retail_price === 0 || data?.contract_price === 0

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleToggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  if (isOrdersetSelected || isTestPriceZero) {
    return null
  }

  return (
    <OrdersetCategoryTestItemLayout>
      <Checkbox
        value={panelCode}
        styles={() => ({
          input: {
            '&:checked': { backgroundColor: '#d76acd', borderColor: '#d336c3' },
          },
        })}
        disabled={isOrdersetSelected || isTestPriceZero}
      />
      <AccordionContent>
        <AccordionSection onClick={handleToggleAccordion}>
          <AccordionTitle>
            <b>{panelCode}</b> {panelName}
          </AccordionTitle>
          <Tooltip label="Client Bill">
            <TestRetailPrice>{panelContractPriceDisplay}</TestRetailPrice>
          </Tooltip>
          <Tooltip label="Patient Bill">
            <TestRetailPrice>{panelRetailPriceDisplay}</TestRetailPrice>
          </Tooltip>
          {isOpen ? <ChevronDownIcon /> : <ChevronUpIcon />}
        </AccordionSection>

        {isOpen && (
          <AccordionContent>
            {isByGroups && (
              <PrimaryHeaderItem>
                <b>{panelCode}</b> {panelName}
              </PrimaryHeaderItem>
            )}

            {data?.tests?.map((test) => (
              <SecondaryHeaderItem key={test.result.code}>
                <b>{test.result.code}</b> {test.result.name}
              </SecondaryHeaderItem>
            ))}
          </AccordionContent>
        )}
      </AccordionContent>
    </OrdersetCategoryTestItemLayout>
  )
}
